/* eslint-disable no-param-reassign */
// @ts-nocheck
export default {
    SET_WORKER_SETTING_DIALOG_OPEN(state, isOpen) {
        state.isWorkerSettingDialogOpen = isOpen;
    },
    SET_SELECTED_SETTING_GROUP(state, group) {
        state.selectedSettingGroup = group;
    },
    // 현재 필터 검색은 없으나 형태 유지
    SET_FILTER_OPTION({ filterOption }, payload) {
        Object.entries(payload).forEach(([key, value,]) => {
            filterOption[key] = value;
        });
    },
    SET_WORKER_CASH_AUTO_DEDUCT_GROUP_REGISTER_LIST: (state, registerList) => {
        state.registerList = registerList;
    },
    SET_WORKER_CASH_AUTO_DEDUCT_GROUP_UNREGISTER_LIST: (state, unregisterList) => {
        state.unregisterList = unregisterList;
    },
    POST_WORKER_CASH_AUTO_DEDUCT_GROUP_REGISTER: () => {
        // subscribe mutation only
    },
    GET_WORKER_CASH_AUTO_DEDUCT_GROUP_WORKER_LIST(state, workerList) {
        state.workerCashAutoDeductGroupWorkerList = workerList;
    },
    GET_WORKER_CASH_AUTO_DEDUCT_GROUP_AVAILABLE_WORKER_LIST(state, workerList) {
        state.workerCashAutoDeductGroupAvailableWorkerList = workerList;
    },
    CLEAR_SELECTED_SETTING_GROUP(state) {
        state.selectedSettingGroup = {};
    },
    CLEAR_WORKER_CASH_AUTO_DEDUCT_GROUP_WORKER_LIST(state) {
        state.workerCashAutoDeductGroupWorkerList = [];
    },
    CLEAR_WORKER_CASH_AUTO_DEDUCT_GROUP_AVAILABLE_WORKER_LIST(state) {
        state.workerCashAutoDeductGroupAvailableWorkerList = [];
    },
    CLEAR_WORKER_CASH_AUTO_DEDUCT_GROUP_REGISTER_LIST(state) {
        state.registerList = [];
        state.unregisterList = [];
    },
};
